export default (val) => {
  if (!val) {
    return '';
  }

  const value = val.toString();
  const newVal = value.split('_').join(' ');
  return newVal.charAt(0).toUpperCase() + newVal.slice(1);
};



// WEBPACK FOOTER //
// ./src/filter/formatTag.js